import { OctHeaderWrapper } from '@oceantech/oceantech-ui'
import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { PERMISSION_ABILITY, PERMISSIONS } from '../../app/constants'
import { useAuth } from '../../app/modules/auth'
import { KEY_LOCALSTORAGE, TYPE_MENU } from '../../app/modules/auth/core/_consts'
import { HeaderRemindMenu } from '../../app/modules/remind/components/headerRemindMenu/HeaderRemindMenu'
import { checkMenuByPermissions, hasAuthority } from '../../app/modules/utils/functionUtils'
import { localStorageItem } from '../../app/modules/utils/localStorage'
import { allMenu } from '../../app/pages/homepage/listMenu'
import { reInitMenu } from '../helpers'
import {
  ActivityDrawer,
  DrawerMessenger,
  InviteUsers,
  ThemeModeProvider,
  UpgradePlan,
} from '../partials'
import SwitchMenu from '../partials/layout/header-menus/SwitchMenu'
import { Content } from './components/content'
import { HeaderWrapper } from './components/header'
import { Sidebar } from './components/sidebar'
import SidebarProvider from './components/sidebar/SidebarContext'
import { PageDataProvider } from './core'

const MasterLayout = () => {
  const location = useLocation();
  const { logout } = useAuth();
  const changeMenu = localStorageItem.get(KEY_LOCALSTORAGE.SWITCH_MENU);
  const checkedMenu = checkMenuByPermissions(allMenu);
  const configuration = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION);
  const isHorizontalMenu = configuration?.menu === TYPE_MENU.HORIZONTAL;

  useEffect(() => {
    reInitMenu()
  }, [location.key])

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
          <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
            {isHorizontalMenu ?
              <OctHeaderWrapper
                onLogout={logout}
                menuOptions={checkedMenu}
                hasIntl
                // userActions={<SwitchMenu />}
                headerActions={
                  hasAuthority(PERMISSIONS.REMIND, PERMISSION_ABILITY.VIEW) ?
                    <HeaderRemindMenu className={isHorizontalMenu ? "text-muted" : ""} bageClassName={isHorizontalMenu ? "spaces t-5 w-20 h-20" : ""}/> : <></>
                }
              />
              :
              <HeaderWrapper />
            } 

            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
              <SidebarProvider>
                {!isHorizontalMenu && <Sidebar />}
              </SidebarProvider>
              <div className='app-main flex-column flex-row-fluid justify-content-between' id='kt_app_main'>
                <div className='d-flex flex-column flex-column-fluid'>
                  {/* <ToolbarWrapper /> */}
                  <Content>
                    <Outlet />
                  </Content>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* begin:: Drawers */}
        <ActivityDrawer />
        {/* <RightToolbar /> */}
        <DrawerMessenger />
        {/* end:: Drawers */}

        {/* begin:: Modals */}
        <InviteUsers />
        <UpgradePlan />
        {/* end:: Modals */}
        {/* <ScrollTop /> */}
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export { MasterLayout }

